import React from "react";
import { Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import Slider from "react-slick";

const MainSlider = ({ banners }) => {
  const { isAuth } = useSelector((state) => state.auth);
  const isDesktop = window?.screen?.width > 767 ? true : false;

  const slidesToShow = isDesktop ? 3 : 1;
  const settings = {
    dots: true,
    // fade: true,
    arrows: false,
    autoplay: true,
    infinite: true,
    speed: 1000,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
  };
  return (
    <div>
      <Slider {...settings}>
        {banners &&
          banners?.length &&
          banners.map((b, index) => {
            return (
              <div className="position-relative" key={index}>
                <img src={b.link} alt="First Slide" width={385} height={400} />
                {(b?.ctabtns?.length &&
                  b.ctabtns.map((c, i) => {
                    return (
                      <div key={i} className="banner-btn">
                        <Button
                          variant="primary"
                          className="start-btn"
                          onClick={() => {
                            window.location.href = c.actionLink;
                          }}
                        >
                          {c.label}
                        </Button>
                      </div>
                    );
                  })) ||
                  null}
              </div>
            );
          })}
      </Slider>
    </div>
  );
};

export default MainSlider;
